/**
 * 單按鈕提示框，用於操作結果或錯誤訊息提示。
 */
export default function AlertDialog({
  open,
  title = '提示',
  message,
  confirmLabel = '知道了',
  onClose,
}) {
  if (!open) {
    return null;
  }

  return (
    <div className="confirm-dialog-overlay" role="presentation" onClick={onClose}>
      <div
        className="confirm-dialog"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="alert-dialog-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="confirm-dialog__content">
          <div className="confirm-dialog__icon" aria-hidden="true">
            !
          </div>
          <div className="confirm-dialog__text">
            <h4 id="alert-dialog-title">{title}</h4>
            {message ? <p className="confirm-dialog__message">{message}</p> : null}
          </div>
        </div>
        <div className="confirm-dialog__actions">
          <button type="button" className="btn btn-primary" onClick={onClose}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
